export default {
    ufCurrentlyManagingDropdown: 'topbar/dropdown/currentlyManaging',
    ufSelectWholesalerBtn: 'topbar/btn/selectWholesaler',
    ufSelectWholesalerDropdown: 'topbar/dropdown/selectWholesaler',
    ufScopeDropdown: 'topbar/dropdown/scope',
    ufAccountSettingsBtn: 'topbar/btn/accountSettings',
    ufPendingApproval: 'topbar/btn/pendingApproval',
    ufSupportLink: 'topbar/btn/supportLink',
};
